<template>
  <ValidationObserver ref="form" v-if="deliveryConstraints">
    <v-row>
      <v-col cols="12" sm="6" >
        <ValidationProvider
          :rules="defaultConstraints ? 'required|min_value:0' : 'min_value:0'"
          name="delivery_constraints_price"
          v-slot="{ errors }"
        >
          <v-text-field
            :label="$t('deliveryMethod.defaultPrice')"
            v-model="deliveryConstraints.price"
            type="number"
            :suffix="currency"
            :error-messages="errors"
            :clearable="!defaultConstraints"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="6">
        <ValidationProvider
         :rules="defaultConstraints ? 'required|min_value:0' : 'min_value:0'"
          name="delivery_constraints_delay"
          v-slot="{ errors }"
        >
          <v-text-field
            :label="$t('deliveryMethod.defaultDelay')"
            v-model="deliveryConstraints.delivery_delay"
            type="number"
            :suffix="$t('deliveryMethod.hours')"
            :error-messages="errors"
            :clearable="!defaultConstraints"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <span v-if="!defaultConstraints">
      <v-divider></v-divider>
      <v-card-text>{{$t('deliveryMethod.applicationConditions')}}</v-card-text>
      <v-row>
        <v-col cols="12" sm="6" >
          <v-row>
            <v-card-text class='py-0'>{{ $t('deliveryMethod.totalPriceOrder') }}</v-card-text>
            <v-col cols="12" sm="6" class='py-0'>
              <ValidationProvider
                rules="required|min_value:0"
                name="application_conditions_total_price_min"
                v-slot="{ errors }"
              >
                <v-text-field
                  :label="$t('deliveryMethod.min')"
                  v-model="deliveryConstraints.application_conditions.total_price.min"
                  type="number"
                  :suffix="currency"
                  :error-messages="errors"
                  append-icon=' '
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" class='py-0'>
              <ValidationProvider
                :rules="deliveryConstraints.application_conditions.total_price.min > 0 ?
                'min_value:'+deliveryConstraints.application_conditions.total_price.min : 'min_value:0'"
                name="application_conditions_total_price_max"
                v-slot="{ errors }"
              >
                <v-text-field
                  :label="$t('deliveryMethod.max')"
                  v-model="deliveryConstraints.application_conditions.total_price.max"
                  type="number"
                  :suffix="currency"
                  clearable
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" >
          <v-row>
            <v-card-text class='py-0'>{{ $t('deliveryMethod.totalWeightOrder') }}</v-card-text>
            <v-col cols="12" sm="6" class='py-0'>
              <ValidationProvider
                rules="required|min_value:0"
                name="application_conditions_total_weight_min"
                v-slot="{ errors }"
              >
                <v-text-field
                  :label="$t('deliveryMethod.min')"
                  v-model="deliveryConstraints.application_conditions.total_weight.min"
                  type="number"
                  suffix="kg"
                  :error-messages="errors"
                  append-icon=' '
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" class='py-0'>
              <ValidationProvider
                :rules="deliveryConstraints.application_conditions.total_weight.min > 0 ?
                'min_value:'+deliveryConstraints.application_conditions.total_weight.min : 'min_value:0'"
                name="application_conditions_total_weight_max"
                v-slot="{ errors }"
              >
                <v-text-field
                  :label="$t('deliveryMethod.max')"
                  v-model="deliveryConstraints.application_conditions.total_weight.max"
                  type="number"
                  suffix="kg"
                  clearable
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </span>
  </ValidationObserver>
</template>

<script>
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
  import { min_value } from 'vee-validate/dist/rules'

  extend('min_value', {
    ...min_value,
    params: ['min']
  })

  export default {
    name: "deliveryConstraints",
    components: {
      ValidationProvider,
      ValidationObserver
    },
    props: {
      deliveryConstraints: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      },
      currency: {
        type: String,
        default: "EUR"
      },
      defaultConstraints: {
        type: Boolean,
        default: false
      },
      areNewConstraints: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      }
    },
    methods: {
      validateForm() {
        return this.$refs.form.validate();
      }
    }
  }
</script>

